var map = {
	"./A.mp3": 7089,
	"./B.mp3": 8287,
	"./C.mp3": 7960,
	"./D.mp3": 74,
	"./E.mp3": 9100,
	"./F.mp3": 1249,
	"./G.mp3": 4129,
	"./H.mp3": 6760,
	"./I.mp3": 4669,
	"./J.mp3": 9853,
	"./K.mp3": 726,
	"./L.mp3": 7194,
	"./M.mp3": 1743,
	"./N.mp3": 3092,
	"./O.mp3": 5895,
	"./P.mp3": 5297,
	"./Q.mp3": 5366,
	"./R.mp3": 3761,
	"./S.mp3": 3282,
	"./T.mp3": 1294,
	"./U.mp3": 6394,
	"./V.mp3": 1138,
	"./W.mp3": 3278,
	"./X.mp3": 1032,
	"./Y.mp3": 817,
	"./Z.mp3": 5615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7889;